import * as React from 'react';
import PropTypes from 'prop-types';

export const DashboardIframe = ({ url }) => {
    return (
        <iframe
            title="Public Health Agency Authoring Dashboard"
            style={{ width: '100vw', height: 'calc(100vh - 200px)' }}
            src={url}
        ></iframe>
    );
};

export default DashboardIframe;

DashboardIframe.propTypes = {
    url: PropTypes.string
};
